import { createSlice } from '@reduxjs/toolkit';
import { createAsyncThunkWithLoggingAndRetry } from '../../store/middleware/thunk_helper';
import { PENDING, REQUESTING, SUCCESS, FAILED } from '../../actions/statusTypes';

import {
  getEmployers as getEmployersService,
  updateEmployer as updateEmployerService,
  createEmployer as createEmployerService,
} from '../../services/baseConfigService';

export const getEmployers = createAsyncThunkWithLoggingAndRetry('baseConfig/getEmployers', () => {
  return getEmployersService();
});

export const updateEmployer = createAsyncThunkWithLoggingAndRetry(
  'baseConfig/updateEmployer',
  ({ employer }) => {
    return updateEmployerService(employer);
  }
);

export const createEmployer = createAsyncThunkWithLoggingAndRetry(
  'baseConfig/createEmployer',
  ({ employer }) => {
    return createEmployerService(employer);
  }
);

const INITIAL_STATE = {
  status: PENDING,
  error: null,
  employers: [],
  saveEmployerStatus: PENDING,
  saveEmployerError: null,
};

const baseConfigSlice = createSlice({
  name: 'baseConfig',
  initialState: INITIAL_STATE,
  reducers: {
    resetState: (state) => {
      return {
        ...INITIAL_STATE,
        employers: state.employers,
      };
    },
    resetSaveStatus: (state) => {
      return {
        ...state,
        saveEmployerStatus: PENDING,
        saveEmployerError: null,
      };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getEmployers.pending, (state) => {
        state.status = REQUESTING;
        state.error = null;
      })
      .addCase(getEmployers.fulfilled, (state, action) => {
        state.status = SUCCESS;
        state.error = null;
        state.employers = action.payload;
      })
      .addCase(getEmployers.rejected, (state, action) => {
        state.status = FAILED;
        state.error = action.payload;
      })
      .addCase(updateEmployer.pending, (state) => {
        state.saveEmployerStatus = REQUESTING;
        state.saveEmployerError = null;
      })
      .addCase(updateEmployer.fulfilled, (state, action) => {
        state.saveEmployerStatus = SUCCESS;
        state.saveEmployerError = null;
      })
      .addCase(updateEmployer.rejected, (state, action) => {
        state.saveEmployerStatus = FAILED;
        state.saveEmployerError = action.payload;
      })
      .addCase(createEmployer.pending, (state) => {
        state.saveEmployerStatus = REQUESTING;
        state.saveEmployerError = null;
      })
      .addCase(createEmployer.fulfilled, (state, action) => {
        state.saveEmployerStatus = SUCCESS;
        state.saveEmployerError = null;
      })
      .addCase(createEmployer.rejected, (state, action) => {
        state.saveEmployerStatus = FAILED;
        state.saveEmployerError = action.payload;
      });
  },
});

export const { resetState, resetSaveStatus } = baseConfigSlice.actions;
export default baseConfigSlice.reducer;
